import {poll} from '@yourcoach/async-utils';

import type {Expand} from '../types';

import {envManager} from '../../utils/env';
import {subtenantExpandCommon} from '../subtenant';
import {userExpandCommon} from '../user';
import {extendExpand} from '../utils/expand';

const baseOfferExpand: Expand = {
  offer: [
    'avatar_id',
    ['client_id', {name: 'Client not found'}, userExpandCommon],
    ['concierge_id', {name: 'Concierge not found'}, userExpandCommon],
    ['employer_id', {name: 'Employer not found'}, userExpandCommon],
  ],
};

export const offerExpandCommon: Expand = extendExpand(baseOfferExpand, [
  ['parent_offer_id->parent_offer', null, baseOfferExpand],
]);

poll(
  () => envManager.isReady,
  () => {
    if (envManager.isCore) {
      extendExpand(
        offerExpandCommon,
        [
          [
            'available_for_subtenant_ids->subtenants',
            null,
            subtenantExpandCommon,
          ],
        ],
        true,
      );
    }
  },
);
